<script setup>
</script>

<template>
  <div id="app-root">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>
</template>

<style lang="scss">
#app-root {
  @include font-primary();
  background-color: $color-gray;
  color: $color-black;
}

a {
  color: $color-black;
  text-decoration: none;
}

/* stylelint-disable selector-type-no-unknown */
g-heading:not(:defined) {
  display: block;
  @include font-primary-weight-bold();
}

g-heading:not(:defined)::before {
  content: attr(content);
}

g-heading[size='1']:not(:defined) {
  font-size: 2rem;
  line-height: 1.2;
}

g-heading[size='3']:not(:defined) {
  font-size: 1.17rem;
  line-height: 1.3;
  margin-bottom: 1rem;
}

g-input:not(:defined),
g-drop-down:not(:defined) {
  display: block;
  width: 100%;
}

g-switch:not(:defined) {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
}

g-copy:not(:defined) {
  display: block;
}

g-show-more:not(:defined) {
  display: inline-block;
  padding: 0.5rem 2rem;
}

g-show-more:not(:defined)::before {
  content: attr(text);
}

g-loader:not(:defined) {
  display: block;
}
/* stylelint-enable selector-type-no-unknown */
</style>
